import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatBottomSheet, MatBottomSheetModule, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { BasicButtonComponent } from 'src/app/core/basic-button/basic-button.component';
import { EventsService, UtilService, VariablesService, VwoService } from 'src/app/shared/services';
import { ActivatedRoute } from '@angular/router';
export type UnifiedOverlayMode = 'auto' | 'dialog' | 'sheet';

@Component({
  selector: 'app-exit-intent',
  standalone: true,
  imports: [CommonModule, NgIf, MatDialogModule, MatBottomSheetModule, MatIconModule, BasicButtonComponent],
  templateUrl: './exit-intent-component.component.html',
  styleUrls: ['./exit-intent-component.component.scss']
})

export class ExitIntentComponent {

  @ViewChild('exitIntentModal', { static: true }) exitIntentModal!: TemplateRef<HTMLElement>;

  @Output() handleHelp = new EventEmitter<void>();
  @Output() handleMaybeLater = new EventEmitter<void>();

  @Input() subtitle: string = '';
  @Input() btnlabel: string = '';
  @Input() desc: string = '';
  @Input() contributeDetails;
  @Input() currency;
  @Input() mode: UnifiedOverlayMode = 'auto';
  @Input() disableClose: boolean = false;
  @Input() showClose: boolean = true;
  @Input() supporterCount: number = 850;

  private dialogRef?: MatDialogRef<any>;
  private sheetRef?: MatBottomSheetRef<any>;

  constructor(
    private dialog: MatDialog,
    private bottomSheet: MatBottomSheet,
    public util: UtilService,
    public vars: VariablesService,
    public vwo: VwoService,
    public events: EventsService,
    public actRoute: ActivatedRoute
  ) { }

  // Open the overlay
  open(): void {
    const useSheet = this.mode === 'sheet' || (this.mode === 'auto' && this.util.isMobile());
    if (useSheet) {
      this.sheetRef = this.bottomSheet.open(this.exitIntentModal, {
        disableClose: this.disableClose,
        panelClass: 'exit-intent-sheet'
      });
      this.sheetRef.backdropClick().subscribe(() => {
        this.sendEventOnBackClick();
      });

    } else {
      this.dialogRef = this.dialog.open(this.exitIntentModal, {
        disableClose: this.disableClose,
        panelClass: 'exit-intent-dialog'
      });
      this.dialogRef.backdropClick().subscribe(() => {
        this.sendEventOnBackClick();
      });
    }
  }

  //send event on back click
  sendEventOnBackClick() {
    const ePayload = {
      eventName: 'donation_confirmation',
      page_name: this.vars.pageName,
      event_type_id: this.vars.fundraiser.id,
      info_1: 'close_btn_popup',
      info_2: this.contributeDetails?.min_donation
    };
    this.events.sendSystemEvent(ePayload).subscribe(_ => _);
  }

  // Close the overlay
  handleClose() {
    this.closePopup();
    const ePayload = {
      eventName: 'donation_confirmation',
      page_name: this.vars.pageName || 'home',
      event_type_id: this.vars.fundraiser.id,
      info_1: 'close_btn_popup',
      info_2: this.contributeDetails?.min_donation
    };
    this.events.sendSystemEvent(ePayload).subscribe(_ => _);

  }

  //close popup
  closePopup() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    if (this.sheetRef) {
      this.sheetRef.dismiss();
    }
  }

  // Handle the primary action
  HandleHelp() {
    const isStoriesPage = this.vars.pageName?.match('stories');
    const isMobile = this.util.isMobile();
    const params = { ...this.actRoute.snapshot.queryParams };
    if (isStoriesPage && !isMobile && params.payment === 'options') {
      this.dialog.closeAll();
    } else {
      this.closePopup();
    }
    this.handleHelp.emit();
    this.vars.ShowIntentWithMinAmount.next(true);
  }

  // Handle the secondary action
  maybeLater() {
    this.vars.ShowIntentWithMinAmount.next(false);
    if (this.dialog) {
      this.dialog.closeAll();
    }
    if (this.bottomSheet) {
      this.bottomSheet.dismiss();
    }
    this.handleMaybeLater.emit();
  }
}


